export default __webpack_public_path__ + "6767efc0487d89c7afabc2ee857b7d87.gif";